import {formValues} from "./FeatureToggleList";

export default async function updateOptIn(values : formValues): Promise<Response> {
  const location = new URL(window.location.href)
  const queryParams = new URLSearchParams(location.search)

  const SDK_KEY = queryParams.get("sdkKey") || queryParams.get("envKey") || ''
  const USER_ID = queryParams.get("userId") || ''

  return await fetch(`https://sdk-api.devcycle.com/v1/optIns/${USER_ID}`, {
    method: 'PUT',
    headers: {
      'Authorization': SDK_KEY,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(values)
  })
}
